import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    // If returning from Emergent OAuth, let the callback exchange the session first.
    if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const loginLocal = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("thom_token", r.data.access_token);
    setUser(r.data.user);
    return r.data.user;
  };

  const registerLocal = async (payload) => {
    const r = await api.post("/auth/register", payload);
    localStorage.setItem("thom_token", r.data.access_token);
    setUser(r.data.user);
    return r.data.user;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {}
    localStorage.removeItem("thom_token");
    setUser(null);
  };

  const emergentSession = async (session_id) => {
    const r = await api.post("/auth/emergent/session", { session_id });
    localStorage.setItem("thom_token", r.data.access_token);
    setUser(r.data.user);
    return r.data.user;
  };

  return (
    <AuthContext.Provider value={{ user, loading, loginLocal, registerLocal, logout, emergentSession, refresh: checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
